/**
 * AIRA's chat drawer (Figma `Drawer` 440×970): opened by her floating ball on any page.
 * One thread per shopper — the drawer and the playground column read the same history.
 */
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAiraDrawerStore = defineStore('aira-drawer', () => {
  const open = ref(false)

  function show() {
    open.value = true
  }

  function hide() {
    open.value = false
  }

  return { open, show, hide }
})
